export const enrollLearnersWizardText = {
  saveButton: 'Save',
  ModalHeader: 'Add Learners',
  DateHeading: 'Course Completion Date',
  DatePlaceholder: '(Optional)',
  searchLearners: 'Search Learners',
  nameOrEmail: 'Learner name or email',
  cantFindLearners: 'No results found',
};
